import styled from 'styled-components';
import {
  darken,
} from 'polished';
import {
  NavLink,
} from 'react-router';

export const Wrapper = styled.div<{ width: string }>`
  display: flex;
  justify-content: space-around;
  padding: 10px;
  border: 0.73px solid #E9E9E9;
  box-shadow: 0px 2.91px 2.91px 0px #00000040;
  background: #FAFAFA;
  border-radius: 3.64px;

  & > div {
    width: ${props => props.width};
  }

  & > hr {
    width: 1px;
    height: auto;
    align-self: stretch;
    background: #D9D9D9
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: 30px 20px;
`;

export const Title = styled.h4`
  color: #333A3D;
  font-weight: 600;
  font-size: 17.45px;
  text-align: center;
  white-space: pre-line;
  margin: 20px 0;
`;

export const Count = styled.span`
  font-weight: 600;
  font-size: 32.73px;
  line-height: 100%;
  text-align: center;
`;

export const Link = styled(NavLink)`
  display: block;
  background-color: #fff;
  border: 1px solid ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
  padding: 8px 10px;
  border-radius: 50px;
  transition: all 0.2s linear;
  transform: translatey(3px);
  width: 100%;
  min-width: 92px;
  max-width: 175px;

  &:hover {
    color: ${props => darken(0.05, props.theme.colors.primary)};
    border-color: ${props => darken(0.05, props.theme.colors.primary)};
    background-color: #fff;
  }
`;

export const CounterProgress = styled.div`
  width: 85px;
  height: 150px;
  svg {
    width: 100%;
    height: 100%;
  }
`;
